<template>
    <div class="placeholder-box text-center">
        <div class="placeholder-icon">
            <i class="iconfont icon-empty" :class="[`icon-${type}`]"></i>
        </div>
        <p class="placeholder-msg">No relevant content</p>
    </div>
</template>

<script>
export default {
    name: 'placeholder-box',

    props: {
        type: String,
        message: String,
    },
};
</script>

<style lang="scss">
.placeholder-box {
    width: 100%;
    padding: 20px 0;

    .placeholder-icon {
        font-size: 40px;
        color: #BCBCBC;
        // width: 30px;
        // height: 30px;
        line-height: 30px;
        text-align: center;
        // border-radius: 50%;
        // background: #F2F2F2;
        margin: 0 auto;
    }

    .placeholder-msg {
        color: #BCBCBC;
        font-size: 14px;
        margin: 10px;
    }
}
</style>
